import { Component, Vue, Watch } from 'vue-property-decorator'
import Multiselect from 'vue-multiselect'
import textInput from '../../../components/text-input/text-input';
import draggable from 'vuedraggable'
import { ISerpBookCatNames, IKeywordService, IKeywordChangeParams } from '@/types';

@Component({
  components: {
    Multiselect,
    textInput,
    draggable,
  }
})

export default class ManageKeywords extends Vue {

  private namespace: string = '/Console';

  private services: ISerpBookCatNames[] | null = null;

  private selectedService: IKeywordService | null = null;

  private groupSelected: {[key: string]: boolean} = {};

  private extraGroupName: string = '';

  private extraGroupOpen: boolean = false;

  private extraKeywordName: {label: string, index: number}[] | null = null;

  private extraKeywordGroup: string = '';

  private extraKeywordOpen: boolean = false;

  private alertMessage: string = '';

  private error: boolean = false;

  private service: {label: string, values: ISerpBookCatNames} = {
    label: '',
    values: {
      serpBookId: 0, 
      domain: '', 
      categoryName: '', 
      mainGroupHasKeyword: false
    }
  };

  private get UnassignedKeywords () {

    if (this.selectedService != null) {
      
      return this.selectedService.unassignedKeywords.map((item, i) => ({
        label: item.keyword,
        index: i
      }));
    }

    return null;
  }

  private get SerpbookNames (): {label: string, values: ISerpBookCatNames}[] | null {

    if (this.services != null) {

      return this.services.map(service => {

        const {categoryName} = service;

        return {
          label: categoryName,
          values: {
            ...service
          }
        };
      });
    }

    return null;
  }

  private get SerpbookName () {
    
    return this.service;
  }

  private set SerpbookName (service: {label: string, values: ISerpBookCatNames}) {

    // if (service.values.serpBookId != this.SerpbookName.values.serpBookId) {
      this.service = service;
      this.selectedService = null;
      this.getService();
    // }
  }

  beforeMount () {

    this.getServices();
  }

  private toggleGroup (name: string) {
  
    if (this.groupSelected[name] != null && this.groupSelected[name]) {
      
      this.groupSelected[name] = false; 
    } else {

      this.groupSelected[name] = true;
    }

    return this.groupSelected = {...this.groupSelected};
  }

  private changeKeyword (event: string, options: {instance: Partial<IKeywordService>, group: string, item: number, value?: (boolean | string)}) {

    const events: {[key: string]: Function} = {

      remove: ({self, arr, index}: IKeywordChangeParams) => {
        if (self.selectedService != null) {

          self.selectedService.unassignedKeywords.push({
            keyword: arr[index].keyword,
            visible: true,
          });
        }

        arr.splice(index, 1)
      },

      change: ({arr, index, value}: IKeywordChangeParams) =>
        arr[index].visible = !value, 
    };

    if (this.selectedService != null) {

      if (options.instance instanceof Array) {

        return options.instance.find(group => {

          if (group.name === options.group) {

            return events[event]({
              self: this,
              arr: group.keywords, 
              index: options.item,
              value: options.value
            });
          }
        });
      }

      return events[event]({
        self: this,
        arr: options.instance.keywords, 
        index: options.item,
        value: options.value
      });
    }
  }

  private openUnassignedKeywords ( groupName: string ) {

    this.extraKeywordOpen = !this.extraKeywordOpen

    this.extraKeywordGroup = groupName;
  }

  private addKeyword () {
    
    if ( this.selectedService != null && this.extraKeywordName != null) {

      const isExtraGroup = this.selectedService.extraGroups.find( group => group.name === this.extraKeywordGroup );
      
      this.extraKeywordName.forEach( keyword => {

        if ( this.selectedService != null ) {

          if ( isExtraGroup ) {

            isExtraGroup.keywords.push({
              keyword: keyword.label,
              visible: true
            });
          } else {

            this.selectedService.mainGroup.keywords.push({
              keyword: keyword.label,
              visible: true
            });
          }
        } 
      });

      this.selectedService.unassignedKeywords = this.selectedService.unassignedKeywords.filter( 
        (item, i) => this.extraKeywordName != null && !this.extraKeywordName.some(selected => selected.label === item.keyword));
      
      this.extraKeywordName = null;

      this.extraKeywordOpen = !this.extraKeywordOpen;
    }
  }

  private cancelAddKeywords () {
    
    this.extraKeywordOpen = !this.extraKeywordOpen;

    this.extraKeywordName = null;
  }

  private addGroup () {
    
    if (this.selectedService != null) {

      this.selectedService.extraGroups.push(
        {
          name: this.extraGroupName,
          order: this.selectedService.extraGroups.length + 1,
          keywords: [],
        }
      );

      this.extraGroupOpen = !this.extraGroupOpen;
    }
  }

  private removeGroup (order: number) {
  
    if (this.selectedService != null) {

      this.selectedService.extraGroups.splice(order, 1); 

      this.selectedService.extraGroups.map((group, i) => {
        
        group.order = i + 1;
      });
    }
  }

  private onDragEnd (item: any) {

    if (this.selectedService) {

      this.selectedService.extraGroups.map((group, i) => {

        group.order = i + 1;
      });
    }
  }

  private alertReset () {

    setTimeout(() => {   

      if (this.error) {

        this.error = !this.error;
      }

      this.alertMessage = '';
    }, 5000);
  }

  private async getServices () {

    try {

      const response = await this.$axios.get(`${this.$apiUrl + this.namespace}/SerpBookCategoryNames`);

      this.services = response.data;

    } catch(err) {

      console.error(err);
    }
  }

  private async getService () {

    try {

      const response = await this.$axios.get(`${this.$apiUrl + this.namespace}/ManageSerpBookKeywords`, {
        params: {
          serpBookId: this.SerpbookName.values.serpBookId
        }
      });
      
      this.selectedService = response.data;
    } catch(err) {

      console.error(err);
    }
  }

  private async save () {

    try {

      const response = await this.$axios.post(`${this.$apiUrl + this.namespace}/ManageSerpBookKeywords`, {
        ...this.selectedService,
      });

      this.alertMessage = 'Keywords successfuly updated';
      this.alertReset();
    } catch (err) {

      this.error = !this.error;
      this.alertMessage = this.$t('errors.common') as string;
      this.alertReset();
    }
  }
}